/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('frontier-formula-field-d1');
	},
};
